class NavInternal {
	constructor() {
		this.nav = document.querySelector('.nav-internal-container');
		if (!this.nav) return;
		this.init();
	}

	init() {
		const pinNav = new ScrollTrigger.create({
			trigger: this.nav,
			pin: true,
			start: () => {
				return `top ${this.heightHeight()}`;
			},
			end: 'max',
			pinSpacing: false,
			onToggle: self => {
				self.isActive ? this.nav.classList.add('smaller') : this.nav.classList.remove('smaller');
			}
		});

		const links = this.nav.querySelectorAll('a');
		links.forEach(link => {
			link.addEventListener('click', e => {
				e.preventDefault();
				const headerHeight = document.querySelector('.header-navbar').offsetHeight;
				const href = link.getAttribute('href');
				const target = document.querySelector(href);
				const offset = parseInt(`${target.offsetTop} - ${headerHeight}`) - 170;
				window.scrollTo({
					top: offset,
					behavior: 'smooth'
				});
			});
		});
	}

	heightHeight() {
		return document.querySelector('.header-navbar').offsetHeight - 1;
	}
}